module.exports = __webpack_public_path__ + "assets/img/register.1f802535.png";